/*let playButton = $(".bundle-and-save-video__play-btn"),
	videoModal = $(".bundle-and-save-video__modal"),
	videoModalWrapper = $(".bundle-and-save-video__modal-wrapper"),
	videoModalPlayer = $(".bundle-and-save-video__modal-wrapper video"),
	closeModal = $(".bundle-and-save-video__modal_close");

playButton.on("click", function() {
	$("body").addClass("fix");
	videoModal.fadeIn();
	let videoURL;
	if (videoModal.hasClass("external-video")) {
		videoURL = $(".bundle-and-save-video__modal .video-container iframe").attr(
			"src"
		);
		videoURL += "&autoplay=1";
		setTimeout(() => {
			$(".bundle-and-save-video__modal iframe").attr("src", videoURL);
		}, 400);
	} else {
		videoModalPlayer.get(0).play();
	}
});
closeModal.on("click", function() {
	$("body").removeClass("fix");
	videoModal.fadeOut();
	if (videoModal.hasClass("external-video")) {
		$(".bundle-and-save-video__modal-wrapper iframe").attr(
			"src",
			$(".bundle-and-save-video__modal-wrapper .video-container iframe").attr(
				"src"
			).replace('&autoplay=1', '')
		);
	} else {
		videoModalPlayer.get(0).pause();
		videoModalPlayer.get(0).currentTime = 0;
	}
});

videoModal.on("click", function(e) {
	if ($(e.target).is(this) || $(e.target).is(videoModalWrapper)) {
		$("body").removeClass("fix");
		videoModal.fadeOut();
		if (videoModal.hasClass("external-video")) {
			$(".bundle-and-save-video__modal-wrapper iframe").attr(
				"src",
				$(".bundle-and-save-video__modal-wrapper .video-container iframe").attr(
					"src"
				).replace('&autoplay=1', '')
			);
		} else {
			videoModalPlayer.get(0).pause();
			videoModalPlayer.get(0).currentTime = 0;
		}
	}
});*/



// WEBPACK FOOTER //
// ./scripts/modules/video-block.js